import React, { FC, useEffect } from 'react';
import { RootState, useSelector } from 'src/store';
import { useParams } from 'react-router';
import { API } from 'aws-amplify';
import { useDispatch } from 'react-redux';

import { editTextReset } from 'src/store/modules/editText';
import { buttonsReset } from 'src/store/modules/buttons';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';
import setInitValue from 'src/utils/setInitValue';

import {
  initViewValues,
  initTrackingValues,
  ViewTemplates
} from './initValues';

const MultipleChoiceSurveyView: FC = () => {
  const dispatch = useDispatch();

  const currentBranchIndex = useSelector(
    (state: RootState) => state.imageUpload.currentBranchIndex
  );

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (err) {}
    }
    setInitValue(dispatch, {
      ...initViewValues,
      ...initTrackingValues
    });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
    };
  }, []);

  return ViewTemplates[currentBranchIndex];
};

export default MultipleChoiceSurveyView;
